module.exports = __webpack_public_path__ + "img/logo2.d2dd2c87.png";